import { Injectable, signal } from '@angular/core';
import type { Alert } from '~core/constants/alerts.constants';
import { AlertType } from '~core/constants/alerts.constants';

@Injectable({ providedIn: 'root' })
export class AlertService {
    private readonly _alert = signal<Alert|null>(null);

    readonly alert = this._alert.asReadonly();

    createSuccessAlert(message: string) {
        this.createAlert({
            id: this.generateAlertId(),
            message,
            type: AlertType.SUCCESS,
            duration: 5000,
            hasCountdown: true,
        });
    }

    createErrorAlert(message: string) {
        this.createAlert({ id: this.generateAlertId(), message, type: AlertType.ERROR });
    }
/*
    removeAlert(alertToRemove: Alert) {
        this._alert.update((alerts) => alerts.filter((alert) => alert !== alertToRemove));
    }

 */

    private createAlert(alert: Alert) {
        this._alert.set(alert);
    }

    private generateAlertId(): string {
        return Math.random().toString(36).slice(2, 9) + Date.now().toString(36);
    }
}